module.exports = __webpack_public_path__ + "img/icon-oddchange-down.e3deebd1.svg";